<ui-dropdown
    #dropdown
    type="menu"
    class="manage-menu"
    [width]="'150'"
    [minWidth]="150">
    <ng-container *ngFor="let campaign of addToCampaignOptions">
        <ui-dropdown-item
            class="add-to-campaign-item"
            [uiTooltip]="campaign.name"
            [uiTooltipDisabled]="!campaign.name"
            svgIcon="display-campaign"
            (click)="addTo(campaign)">
            {{ campaign.name }}
        </ui-dropdown-item>
    </ng-container>
</ui-dropdown>
